import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { API_BASE_URL } from '../api-base-url.token';

export interface ServiceInterruptionDto {
  message: string;
  active: boolean;
  startsAt: string | null;
  endsAt: string | null;
}

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private http = inject(HttpClient);
  private base = inject(API_BASE_URL);

  getBanner(): Observable<string | null> {
    return this.http
      .get<ServiceInterruptionDto>(`${this.base}/public/v1/service-interruption`)
      .pipe(
        map(dto => (dto.active && dto.message?.trim() ? dto.message.trim() : null)),
        catchError(() => of(null))
      );
  }
}
